/*@ngInject*/
const GetQuotableProductTemplatesRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getQuotableProductTemplates = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/quotableProductTemplates';

        return this.get(url);
    };

    this.processGetResponseData = function (responseData) {
        return _.sortBy(responseData, 'name');
    };
};

angular.module('gw-um-submission')
    .service('getQuotableProductTemplatesRepository', GetQuotableProductTemplatesRepository);
